module.exports = __webpack_public_path__ + "static/img/guangdongmajiang.dca52b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/guangdongmajiang.jpg
// module id = YP1G
// module chunks = 0